export default function getFileExtension(codeVariant) {
  if (codeVariant === 'TS') {
    return 'tsx';
  }
  if (codeVariant === 'JS') {
    return 'js';
  }
  throw new Error("Unsupported codeVariant: ".concat(codeVariant));
}